module.exports = __webpack_public_path__ + "static/logo-eb32c6f3a3ee256ec38a474fde0e4ddd.png";